import { types } from 'mobx-state-tree';
import Address from './Address';
import OperationHours from './OperationHours';

export default types.model('DropoffLocations', {
  name: types.string,
  phone_number: types.string,
  address: Address,
  distance: types.string,
  hours_of_operation: types.array(OperationHours),
  linked_map: types.string,
  embedded_map: types.string,
});
